import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { Column } from "./DataTable";
import { colunasExportaveis, texto } from "./exportarCsv";
import { FilterData } from "@/types/filter";
import { formatBoolean } from "@/utils/format";

// "Seguradora contém Porto": formata o valor como a coluna, montando o item a partir do campo (ex.: segurado.nome)
const descreverFiltro = ({ column, operator, value }: FilterData) => {
  const item = column.field.split('.').reduceRight<any>((v, campo) => ({ [campo]: v }), value);
  const valor = column.type === 'BOOLEAN' ? formatBoolean(value) : texto(column, item) || value;
  return `${column.label} ${operator.name.toLowerCase()} ${valor}`;
}

// PDF em retrato com as colunas visíveis por padrão; a primeira coluna ocupa o espaço que sobra e quebra linha
// Baixa o arquivo: abrir aba depois da busca assíncrona cai no bloqueador de pop-up
export const exportarPdf = (arquivo: string, titulo: string, columns: Column[], itens: any[], filtros: FilterData[], corretora?: string) => {
  const colunas = colunasExportaveis(columns.filter(col => col.show));
  const emitido = new Date().toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
  (pdfMake as any).vfs = (pdfFonts as any).pdfMake.vfs;
  (pdfMake as any).createPdf({
    pageOrientation: 'portrait',
    pageMargins: [24, 32, 24, 32],
    defaultStyle: { fontSize: 8 },
    content: [
      corretora ? { text: corretora, fontSize: 10, bold: true, color: '#666' } : '',
      { text: titulo, fontSize: 14, bold: true },
      { text: `${itens.length} registro${itens.length === 1 ? '' : 's'} · emitido em ${emitido}`, color: '#666', margin: [0, 2, 0, 0] },
      { text: [{ text: 'Filtros: ', bold: true }, filtros.length ? filtros.map(descreverFiltro).join(' · ') : 'nenhum'], margin: [0, 4, 0, 10] },
      {
        layout: 'lightHorizontalLines',
        table: {
          headerRows: 1,
          widths: colunas.map((_, i) => i === 0 ? '*' : 'auto'),
          body: [
            colunas.map(col => ({ text: col.label!, bold: true })),
            ...itens.map(item => colunas.map(col => texto(col, item))),
          ],
        },
      },
    ],
    footer: (pagina: number, total: number) => ({ text: `${pagina} / ${total}`, alignment: 'right', margin: [0, 8, 24, 0], fontSize: 7, color: '#666' }),
  }).download(`${arquivo}-${new Date().toISOString().slice(0, 10)}.pdf`);
}
